import React from "react";
import { Modal } from "react-bootstrap";

import * as S from "./styles";
import { IProps } from "./types";

const ProductVideoModal: React.FC<IProps> = (
  {
    video, show, onHide
  }) => {
  return (
    <S.Wrapper>
      <Modal show={show} onHide={onHide} centered size="lg"
             dialogClassName="custom-dialog">
        <Modal.Body>
          <S.Div>
            <S.Iframe
              src={video} frameBorder="0" allowFullScreen={true}
            />
          </S.Div>
        </Modal.Body>
      </Modal>
    </S.Wrapper>
  )
};

export { ProductVideoModal }